class CollectionExcerpt extends HTMLElement {
  constructor() {
    super();
    this.excerptDiv = this.querySelector('[data-excerpt]');
    this.fullTextDiv = this.querySelector('[data-full-text]');
    this.readMoreBtn = this.querySelector('[data-read-more]');
    this.readLessBtn = this.querySelector('[data-read-less]');
    
    this.readMoreBtn.addEventListener('click', () => this.showFullText());
    this.readLessBtn.addEventListener('click', () => this.showExcerpt());
  }

  showFullText() {
    this.excerptDiv.classList.add('hidden');
    this.fullTextDiv.classList.remove('hidden');
    this.excerptDiv.setAttribute('aria-hidden', 'true');
    this.fullTextDiv.setAttribute('aria-hidden', 'false');
  }

  showExcerpt() {
    this.fullTextDiv.classList.add('hidden');
    this.excerptDiv.classList.remove('hidden');
    this.excerptDiv.setAttribute('aria-hidden', 'false');
    this.fullTextDiv.setAttribute('aria-hidden', 'true');
  }
}

customElements.define('collection-excerpt', CollectionExcerpt);